//
// Constants
//
export const SET_SELECTED_COLOR = 'SET_SELECTED_COLOR'

//
// Actions
//
export const setSelectedColor = color => ({ type: SET_SELECTED_COLOR, color })
